import { Image } from 'app/src/shared/components'
import { PageWidget } from 'app/src/shared/components/PageWidget'
import successImage from 'app/static/images/success_img.png'

export function CancelSuccess(props?: React.PropsWithChildren<{ successTitle?: string; successSubTitle?: string }>) {
  return (
    <PageWidget>
      <div className='mt-2 flex flex-col'>
        <div className='mx-auto'>
          <div className='bold m-auto mx-auto mt-[24px] max-w-xl text-center text-4xl font-bold leading-[64px]'>
            <div className='mx-auto'>{props?.successTitle}</div>
          </div>
          <div className='mx-auto mt-[48px]'>
            <Image
              pt={{ image: { className: 'object-fit mx-auto h-[150px] lg:h-[250px]' } }}
              src={successImage}
              alt='Immagine di successo'
            />
          </div>
        </div>
        <div className='max-w-xxl m-auto mx-auto mt-[48px] text-center'>
          <div dangerouslySetInnerHTML={{ __html: props?.successSubTitle ?? '' }} />
        </div>
        <div className='text mt-4 text-center'>{props?.children && <>{props.children}</>}</div>
      </div>
    </PageWidget>
  )
}
